export const Parent =() =>{
    const openNewWindow = () => {
      // 子ウィンドウに渡したいデータを作成
      const message = {
        id: 5,
        description: "データ受信"
      };
  
      // 子ウィンドウを開く
      const rootPath = window.location.origin 
      console.log("origin:", window.location.origin);
      const popup = window.open(
        rootPath + "/child",
        "_blank",
        "location=no,scrollbars=yes"
      );
      if (popup) {
        // 子ウィンドウにメッセージを送信
        popup.onload = () => popup.postMessage(message, window.location.origin);
      }
    };

    const img = new Image();
    img.onload = function(){
        alert("aaa")
    }
    img.src = "xxx.png"
  
    return (      
        <div className="App">
          <h1>parent</h1>
          <button onClick={() => openNewWindow()}>button</button>
        </div>
    );
  }
  